import React from 'react';
import {FormControl, InputLabel, MenuItem, Select} from '@mui/material';
import {GetFactFindTemplates} from '../../schema-types/GetFactFindTemplates';

export const SelectFactFindTemplate: React.FC<{
  selectedTemplateId: string | null;
  setSelectedTemplateId: React.Dispatch<React.SetStateAction<string | null>>;
  templatesData: GetFactFindTemplates | undefined;
}> = ({selectedTemplateId, setSelectedTemplateId, templatesData}) => {
  return (
    <FormControl fullWidth size="medium">
      <InputLabel style={{top: -2}}>Select Fact Find Template</InputLabel>
      <Select
        style={{minWidth: 300}}
        variant="outlined"
        label="Select Fact Find Template"
        inputProps={{
          'data-select-input': 'Select Template',
        }}
        data-testid="Select Template"
        value={selectedTemplateId}
        onChange={(e) => setSelectedTemplateId(e.target.value as string)}
      >
        {templatesData?.fincalcTemplates?.map((option) => {
          if (!option) {
            return null;
          }
          return (
            <MenuItem
              data-test={option.name}
              key={String(option.fincalcId)}
              value={String(option.fincalcId)}
            >
              {option.name}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};
